import React,{Component} from 'react';
import moment from 'moment';

import * as Excel from "exceljs/dist/exceljs.min.js";
import { saveAs } from "file-saver";

export function generateExcel(reportName, colDefs, dataArray, callback){


	const workbook = new Excel.Workbook();
	const worksheet = workbook.addWorksheet("My Sheet");
	const sheetColumns = [];

	sheetColumns.push({
		header: 'Sl. No',
		key: 'slno',
		width: 10
	});
	
	colDefs.forEach((column)=>{
		if (!column.restrictToExport && column.hidden != true) {
			sheetColumns.push({
				header: column.name,
				key: column.aliasekey ? column.aliasekey : column.key,
				width: column.width > 0 ? column.width/10 : 10
			});
		}
	});

	worksheet.columns = sheetColumns;

	for (var i = 0; i < dataArray.length; i++) {
		let tempData ={};

		tempData['slno'] = i + 1;
		for (var j = 0; j < colDefs.length; j++) {
			if (!colDefs[j].restrictToExport && colDefs[j].hidden != true) {
				var value = '',type = '';
				if ((colDefs[j].format == 'date' || colDefs[j].format == 'dateinput') && dataArray[i][colDefs[j].key]) {
					let tempdate = new Date(dataArray[i][colDefs[j].key]);
					value = moment(new Date(tempdate).toString()).format('DD-MM-YYYY');
				}
				else if (colDefs[j].format == 'datetime')
					value = dateFormat(dataArray[i][colDefs[j].key], 'DD/MM/YYYY hh:mm:ss a') || '';
				else if (colDefs[j].format == 'time')
					value = dateFormat(dataArray[i][colDefs[j].key], 'hh:mm a') || '';
				else if (colDefs[j].format == 'number')
					value = typeof(dataArray[i][colDefs[j].key]) == 'number' ? Number(dataArray[i][colDefs[j].key].toFixed(2)) : 0;
					else if (colDefs[j].format == 'numberonly')
					value = typeof(dataArray[i][colDefs[j].key]) == 'number' ? dataArray[i][colDefs[j].key] : 0;
				else if (colDefs[j].format == 'boolean')
					value = typeof(dataArray[i][colDefs[j].key]) == 'boolean' ? (dataArray[i][colDefs[j].key] == true ? 'Yes' : 'No') : null;
				else if(colDefs[j].format == 'array') {
					if (dataArray[i][colDefs[j].key] && Array.isArray(dataArray[i][colDefs[j].key]))
						value = dataArray[i][colDefs[j].key].toString();
					else
						value = '';
				}
				else if (colDefs[j].format == 'location') {
					if (colDefs[j].fieldformat == 'datetime')
						value = dateFormat(dataArray[i][colDefs[j].fieldname], 'DD/MM/YYYY hh:mm:ss a') || '';
					else if (colDefs[j].fieldformat == 'time')
						value = dateFormat(dataArray[i][colDefs[j].fieldname], 'hh:mm a') || '';
				}
				else
					value = dataArray[i][colDefs[j].key] || '';

				tempData[colDefs[j].aliasekey ? colDefs[j].aliasekey : colDefs[j].key] = value;

			}
		}
		var row = worksheet.addRow(tempData);
		
		row._cells.forEach((cell)=>{
			colDefs.forEach((colDef)=>{
				let key = colDef.aliasekey ? colDef.aliasekey : colDef.key;
				if(cell._column._key == key ){
					if(colDef.format == 'number'){
						worksheet.getCell(cell._address).numFmt = '#,##0.00';
					}
				}
			});
			
		});
	}

	worksheet.getRow(1)._cells.forEach((celladdress)=>{

		worksheet.getCell(celladdress._address).fill = {
			type: 'pattern',
			pattern:'solid',
			fgColor:{ argb:'FFFF66' }
		};

		worksheet.getCell(celladdress._address).font = {
	        bold: true,
	        size: 12,
		};
	});

	workbook.xlsx.writeBuffer().then(function(buffer) {
		const blob = new Blob([buffer], { type: "application/octet-stream" });
		saveAs(blob, reportName + "_" + (moment().format('D-MMM-YYYY')) + ".xlsx");
		callback();
	});
}

export function generateExcelOLD (reportName, colDefs, dataArray, callback) {

	reportName = reportName.replace(/[^A-Za-z0-9_()\s-@]/g, '');

	let reportData = [];
	let needFooter = false;
	let widthArray = [];
	let tempHeaderObj = [];

	tempHeaderObj.push({
		v : 'Sl. No'
	});
	widthArray.push({
		wch : 6
	});
	
	for (var i = 0; i < colDefs.length; i++) {
		if (!colDefs[i].restrictToExport && colDefs[i].hidden != true) {
			
			tempHeaderObj.push({
				v : colDefs[i].name
			})
			widthArray.push({
				wch : colDefs[i].width ? colDefs[i].width / 10 : 10
			});
			if (['sum', 'custom'].indexOf(colDefs[i].footertype) >= 0) {
				needFooter = true;

				if (colDefs[i].footertype == 'sum')
					colDefs[i].custom_isSumAggregaion_Total = 0;
			}
		}
	}

	reportData.push(tempHeaderObj);

	for (var i = 0; i < dataArray.length; i++) {
		let tempData = [{
				v : i + 1
			}];

		for (var j = 0; j < colDefs.length; j++) {
			if (!colDefs[j].restrictToExport && colDefs[j].hidden != true) {
				var value = '',type = '';
				if ((colDefs[j].format == 'date' || colDefs[j].format == 'dateinput') && dataArray[i][colDefs[j].key]) {
					let tempdate = new Date(dataArray[i][colDefs[j].key]);
					value = new Date(tempdate.setTime(tempdate.getTime()+((330/60)*3600*1000))).toString();
					type='d';
				}
				else if (colDefs[j].format == 'datetime')
					value = dateFormat(dataArray[i][colDefs[j].key], 'DD/MM/YYYY hh:mm:ss a') || '';
				else if (colDefs[j].format == 'time')
					value = dateFormat(dataArray[i][colDefs[j].key], 'hh:mm a') || '';
				else if (colDefs[j].format == 'number')
					value = typeof(dataArray[i][colDefs[j].key]) == 'number' ? Number(dataArray[i][colDefs[j].key].toFixed(2)) : null;
				else if (colDefs[j].format == 'boolean')
					value = typeof(dataArray[i][colDefs[j].key]) == 'boolean' ? (dataArray[i][colDefs[j].key] == true ? 'Yes' : 'No') : null;
				else if(colDefs[j].format == 'array') {
					if (dataArray[i][colDefs[j].key] && Array.isArray(dataArray[i][colDefs[j].key]))
						value = dataArray[i][colDefs[j].key].toString();
					else
						value = '';
				}
				else if (colDefs[j].format == 'location') {
					if (colDefs[j].fieldformat == 'datetime')
						value = dateFormat(dataArray[i][colDefs[j].fieldname], 'DD/MM/YYYY hh:mm:ss a') || '';
					else if (colDefs[j].fieldformat == 'time')
						value = dateFormat(dataArray[i][colDefs[j].fieldname], 'hh:mm a') || '';
				}
				else
					value = dataArray[i][colDefs[j].key] || '';

				tempData.push({
					v : value,type:type
				});

				if (colDefs[j].footertype == 'sum' && !dataArray[i]['_restrictFromAggregation'])
					colDefs[j].custom_isSumAggregaion_Total += (typeof(dataArray[i][colDefs[j].key]) == 'number' ? Number(dataArray[i][colDefs[j].key].toFixed(2)) : 0);
			}
		}

		reportData.push(tempData);
	}

	if (needFooter) {
		let tempArray = [];
		tempArray.push({
			v : ''
		});
		for (var i = 0; i < colDefs.length; i++) {
			if (!colDefs[i].restrictToExport && colDefs[i].hidden != true) {
				if (['sum', 'custom'].indexOf(colDefs[i].footertype) >= 0) {
					tempArray.push({
						v : colDefs[i].footertype == 'sum' ? Number(colDefs[i].custom_isSumAggregaion_Total.toFixed(2)) : (!isNaN(colDefs[i].customfootervalue) ? Number(colDefs[i].customfootervalue) : colDefs[i].customfootervalue)
					});
				} else {
					tempArray.push({
						v : '',
					});
				}
			}
		}
		reportData.push(tempArray);
	}

	let wb = {
		SheetNames : [],
		Sheets : {}
	};

	let ws = excel_sheet_from_array_of_arrays(reportData);
	wb.SheetNames.push(reportName);
	wb.Sheets[reportName] = ws;
	ws['!cols'] = widthArray;

	let wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
	saveAs(new Blob([excel_s2ab(wbout)],{type:"application/octet-stream"}), reportName + "_" + (moment().format('D-MMM-YYYY')) + ".xlsx");
	callback();
}

function dateFormat(input, format){
	if (input != '' && input !=null) {
		let dateString = moment(input).format(format ? format : "DD-MMM-YYYY @ h:mm a");
		return dateString;
	}
	return "";
}


export function dateFilter(input) {
	if (input != '' && input !=null) {
		let dateString = moment(input).format("DD-MMM-YYYY");
		return dateString;
	}
	return "";
}


// WEBPACK FOOTER //
// ./public/react/utils/services.js